export function setTitle(title: string) {
  document.title = `${title  } - 人人影视下载分享站`;
}
